import React from "react";

function Report() {
  return (
      <span className="anticon ant-report">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22">
            <g fill="none" fillRule="evenodd">
                  <g fill="#0096dc">
                    <g>
                        <g>
                            <g>
                                <path d="M2 39v-2h1V17h2v1h14.125l-2.999 6 3 6H5v7h1v2H2zm13.89-19H5v8h10.89l-2-4 2-4z" transform="translate(-912 -148) translate(303 81) translate(589 49) translate(18 1)"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </span>
  );
}

export default Report;